import React from '../helpers/react';
import classList from 'ereader-core/dist/classList';

export default React.createClass({
	selectReason : function(){
        this.props.selectReason(this.props.review.reasonId);
    },
  keyDownReason: function(e) {
    if(e.keyCode === 13 || e.keyCode === 32) {
      e.preventDefault();
      e.currentTarget.click();
      return false;
    }
  },
	render : function(){
        let reasonClass = classList('review-reason');
        if (this.props.selected_reason == this.props.review.reasonId) {
            reasonClass.push('selected');
        }
        const labelFor = `review-id-${this.props.review.reasonId}`;
		return (
            <li className={reasonClass}>
                <div className="review-reason-button">
                    <label htmlFor={labelFor} className="text" onClick={this.selectReason} tabIndex={"0"} onKeyDown={(e)=>this.keyDownReason(e)}>{this.props.getDef(this.props.review.reason)}</label>
                    {this.props.children || <input type="radio" id={labelFor} tabIndex={"-1"}/>}
                </div>
            </li>
		);
	}
});


// WEBPACK FOOTER //
// ./src/components/ReviewOption.js